<template>
    <div>
        <div class="integral-header">
            <div class="points" v-if="tabsValue == 0">
            <img src="../../assets/account/points.png" alt="">
            积分 : {{
                GET_USER_INFO.giftPoints }}
            </div>
            <div class="points" v-if="tabsValue == 1">
                <img class="searchPointImg" src="../../assets/account/searchPoint.png" alt="">
           <span class="searchPointTxt">
            搜点 : {{
                GET_USER_INFO.incomePoints }}
           </span>
            </div>
            <div class="points" v-if="tabsValue == 2">
                <img src="../../assets/account/coinSearch.png" alt="">
                <span>
                    搜币 : {{
                GET_USER_INFO.rechargePoints }}
                </span>
            
            </div>
            <div class="points" v-if="tabsValue == 3">
                <img src="../../assets/account/coinSearch.png" alt="">
                <span>
                    红包 : {{ avUserInfo.currentMoney ? avUserInfo.currentMoney  : 0}}
                </span>   
            </div>
            <div>
                <el-button type="success"  size="medium"  @click="goRecharge">
                    购买搜币
                </el-button>
            </div>
        </div>

        <div style="padding: 0 0.8rem;">
            <el-tabs v-model="tabsValue" type="card" @tab-click="tabClick">
                <el-tab-pane :key="item.name" v-for="(item) in tabs" :label="item.title" :name="item.name">
                    <el-table :data="tableList" v-loading="tableLoading" style="width: 100%">
                        <el-table-column prop="createdTime" align="center" label="时间"></el-table-column>
                        <el-table-column align="center" label="数额">
                            <template slot-scope="scope">
                                <template v-if="scope.row.type == 1">
									<span
                                            style="color: red;font-size: 16px;font-weight: 500;padding-right: 5px;">+</span>
                                    {{ scope.row.value }}
                                </template>
                                <template v-else>
									<span
                                            style="color: green;font-size: 16px;font-weight: 700;padding-right: 5px;">-</span>
                                    {{ scope.row.value }}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" align="center" label="描述"></el-table-column>
                    </el-table>
                    <div class="page-box">
                        <el-pagination background layout="prev, pager, next" :current-page="pageObj.pageIndex"
                                       :total="pageObj.total" :page-size="pageObj.pageSize"
                                       @current-change="pageChange">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="红包" name="3" v-if="activityInfo.activityOpen == 1">
                    <el-table :data="recordList" v-loading="loading" style="width: 100%">
                        <el-table-column prop="createTime" align="center" label="时间">
                            <template slot-scope="scope">
                                <template>
                                    {{ moment(scope.row.createTime).format('yyyy-MM-DD HH:mm:ss') }}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="数额">
                            <template slot-scope="scope">
                                <template>
									<span
                                            style="color: red;font-size: 16px;font-weight: 500;padding-right: 5px;">+</span>
                                    {{ scope.row.money }}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  align="center" label="描述">
                            <template slot-scope="scope">
                                <template>
                                    {{ scope.row.source == 1 ? '邀请好友奖励':'排行榜奖励' }}
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page-box">
                        <el-pagination background layout="prev, pager, next"
                                       :total="total"
                                       @current-change="pageChange">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog title="绑定手机" width="500px" :visible.sync="mobilelVisible">
            <el-form
                    :model="mobileBox"
                    :rules="mobileRules"
                    ref="mobileBox"
                    label-width="90px"
                    class="demo-ruleForm"
            >
                <el-form-item label="手机号" prop="account" style="width: 360px;">
                    <el-input v-model="mobileBox.account"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="randomCode" style="width: 400px;">
                    <el-input v-model="mobileBox.randomCode" style="width: 200px;"></el-input>

                    <el-button
                            v-if="!this.timerObj.telTime.num"
                            @click="telCodeFun"
                            type="primary"
                            style="margin-left: 10px;"
                    >验证码
                    </el-button>
                    <el-button v-else style="margin-left: 10px;">{{ this.timerObj.telTime.num }}s</el-button>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
        <el-button @click="mobilelVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitMobile">确 定</el-button>
      </span>
        </el-dialog>

        <el-dialog title="身份认证" width="500px" :visible.sync="identityVisible">
            <el-form
                    :model="identityBox"
                    :rules="identityRules"
                    ref="identityBox"
                    label-width="90px"
                    class="demo-ruleForm"
            >
                <el-form-item label="姓名" prop="name" style="width: 360px;">
                    <el-input v-model="identityBox.name"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard" style="width: 360px;">
                    <el-input :maxlength="18" v-model="identityBox.idCard"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
        <el-button @click="identityVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitIdentity">确 定</el-button>
      </span>
        </el-dialog>
        <m-buy ref="buybuy"></m-buy>
        <!--实名认证提示框-->
        <el-dialog
                title="提示"
                :visible.sync="fixIdentityVisible"
                width="30%"
        >
            <span>充值前请先进行实名认真</span>
            <span slot="footer" class="dialog-footer">
      <el-button @click="fixIdentityVisible = false">取 消</el-button>
      <el-button type="primary" @click="fixIdentity">确 定</el-button>
    </span>
        </el-dialog>
    
        <!-- 购买积分提示语 -->
        <el-dialog title="提示" :visible.sync="BuyPointsMsg" width="30%">
        <span class="BuyPointsMsg">目前网站只能充值搜币（仅用于搜币类模型），不能充值积分（仅用于积分类模型），积分可以通过每日登录或上传模型获取。</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="BuyPointsMsg = false">取 消</el-button>
        
        </span>
        </el-dialog>

    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import {
        pointsListApi, mediaSetApi
    } from '@/api/resource';
    import {myAccountApi, updateAccountApi, identityApi, forgetPwdApi} from "@/api/user";
    import {emailCodeApi, bindAccountApi, telCodeApi, otherLoginApi} from "@/api/login";
    import commonMixin from "@/mixins/commonMixin";
    import {
        apply
    } from "@/api/withdrawal.js";
    import { getActivityInfo, getMoneyRecordApi,getAvUserInfoApi } from "@/api/activity";
    import moment from 'moment'
    export default {
        data() {
            return {
                activityInfo:{},
                avUserInfo: {},
                recordList: [],
                loading: false,
                fixIdentityVisible: false,
                fixMobileVisible: false,
                accountInfo: {
                    headImgUrl: "",
                    backgroundImgUrl: "",
                    sex: '',
                    fullName: ''
                },
                mobileBox: {},
                mobileRules: {
                    account: [
                        {required: true, message: "请输入手机", trigger: "blur"},
                        {
                            pattern:
                                /^[1-9][0-9]{10}$/,
                            message: "请正确输入手机",
                            trigger: "blur",
                        },
                    ],
                    randomCode: [
                        {required: true, message: "请填写验证码", trigger: "blur"},
                    ]
                },
                mobilelVisible: false,
                identityBox: {},
                identityRules: {
                    name: [
                        {required: true, message: "请输入姓名", trigger: "blur"}
                    ],
                    idCard: [
                        {required: true, message: "请输入身份证", trigger: "blur"}
                    ]
                },
                identityVisible: false,
                timerObj: {
                    /* 手机号登录倒计时 */
                    telTime: {
                        loading: false,
                        obj: null,
                        num: 0,
                    },
                },
                pageObj: {
                    pageSize: 15,
                    pageIndex: 1,
                    total: 0,
                },
                total:0,
                tableList: [],
                tableLoading: true,
                totalPoints: 0,
                totalNum: 0,

                tabsValue: '0',
                tabs: [
                    {
                        title: '积分',
                        name: '0',
                    },
                    {
                        title: '搜币',
                        name: '2',
                    },
                    {
                        title: '搜点',
                        name: '1',
                    },
                ],
                BuyPointsMsg: false
            };
        },
        created() {
            this.getList();
            this.getMedia();
            this.getActivity();
        },
        computed: {
            ...mapGetters(["GET_USER_INFO", "GET_CART_BADGE", "GET_BELL_BADGE",]),
        },
        methods: {
            moment,
            ...mapMutations({
                SET_USER_INFO: "SET_USER_INFO",
                SET_BUY_VISIBLE: "SET_BUY_VISIBLE"
            }),
            getActivity(){
                getActivityInfo().then(res=>{
                    this.activityInfo = res.data
                    if(this.activityInfo.id) {
                        this.getRecord();
                        this.getAvUserInfo();
                    }
                })
            },
            getAvUserInfo(){
                getAvUserInfoApi({
                    activityId:this.activityInfo.id
                }).then(res=>{
                    this.avUserInfo = res.data
                })
            },
            getRecord(){
                let param = {
                    activityId: this.activityInfo.id,
                    pageSize: 10,
                    pageNum: 1
                }
                getMoneyRecordApi(param).then(res=>{
                    this.recordList = res.data.list
                    this.total = res.data.total
                })
            },
            //点击充值
            goRecharge() {
                this.BuyPointsMsg = true
                if (this.accountInfo.authFlag != 1) {
                    // this.fixIdentity()
                    this.fixIdentityVisible = true
                } else if (!this.accountInfo.phone) {
                    this.fixMobile()
                } else {
                    this.$refs.buybuy.inputNum = 50;
                    this.$refs.buybuy.amount = 50;
                    clearInterval(this.wxtimer); // 清除定时器
                    clearInterval(this.zfbtimer); // 清除定时器
                    this.$refs.buybuy.wxPay();
                    this.$refs.buybuy.zfbPay();
                    this.$refs.buybuy.payVisible = true;
                    // console.log(this.$refs.buybuy.payVisible)
                }

            },

            fixMobile() {
                this.$confirm('您正在绑定手机/邮箱，如果该手机/邮箱已经在本站注册用户，为保证安全，将无法进行绑定！如有疑问请提交工单', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '我已了解',
                    cancelButtonText: '提交工单'
                })
                    .then(() => {
                        this.mobileBox = {};
                        this.mobilelVisible = true;
                    })
                    .catch(action => {
                        /* 点击取消按钮 */
                        if (action === 'cancel') {
                            this.$router.push('/user/workorder');
                        } else {
                        }
                    });
            },
            fixIdentity() {
                this.fixIdentityVisible = false;
                this.identityBox = {};
                this.identityVisible = true;
            },
            getMedia() {
                mediaSetApi()
                    .then((res) => {
                        if (res.code == 200) {
                            this.mediaSetObj = res.data;
                            this.getAccount();
                        }
                    })
                    .catch((err) => {
                        this.getAccount();
                    });
            },
            getAccount() {
                myAccountApi().then(res => {
                    if (res.code == 200) {
                        let accountInfo = res.data;
                        const {initUserAvatarUrl = '', initUserBackGroundUrl = ''} = this.mediaSetObj;
                        const {
                            assetsAuthCount = 0,
                            assetsCount = 0,
                            totalPoints = 0,
                            sellAssetsCount = 0
                        } = accountInfo;

                        if (!accountInfo.headImgUrl) {
                            accountInfo.headImgUrl = initUserAvatarUrl ? initUserAvatarUrl : '';
                        }

                        if (!accountInfo.backgroundImgUrl) {
                            accountInfo.backgroundImgUrl = initUserBackGroundUrl ? initUserBackGroundUrl : '';
                        }

                        this.accountInfo = accountInfo;
                        this.scoreList = [
                            {
                                text: "发布的资产",
                                url: "/user/myAssets",
                                num: assetsCount,
                                icon: require("@/assets/1.png")
                            },
                            {
                                text: "资产被购买",
                                url: "",
                                num: sellAssetsCount,
                                icon: require("@/assets/3.png")
                            },
                            {
                                text: "累计获得积分",
                                url: "/user/integral",
                                num: totalPoints,
                                icon: require("@/assets/2.png")
                            },
                            {
                                text: "畅快用认证",
                                url: "",
                                num: assetsAuthCount,
                                icon: require("@/assets/4.png")
                            }
                        ];
                        this.SET_USER_INFO(accountInfo);
                    }
                });
            },

            /* 短信倒计时 */
            timerTelClick() {
                this.stopTelTime();
                this.timerObj.telTime.num = timeMax;

                const TelTickFun = () => {
                    --this.timerObj.telTime.num;

                    if (this.timerObj.telTime.num <= 0) {
                        this.timerObj.telTime.num = 0;
                        clearInterval(this.timerObj.telTime.obj);
                    }
                };

                TelTickFun();

                this.timerObj.telTime.obj = setInterval(TelTickFun, 1000);
            },
            /* 手机号发送验证码 */
            telCodeFun() {
                this.$refs["mobileBox"].validateField("account", (errorMessage) => {
                    if (!errorMessage) {
                        let params = {
                            phone: this["mobileBox"].account,
                            templateType: 102,
                        };

                        if (this.timerObj.telTime.loading) {
                            return false;
                        }

                        this.timerObj.telTime.loading = true;

                        telCodeApi(params)
                            .then((res) => {
                                const {code, message} = res;
                                if (code == 200) {
                                    this.timerTelClick();
                                } else {
                                    this.$message.error(message);
                                }
                                this.timerObj.telTime.loading = false;
                            })
                            .catch((err) => {
                                this.timerObj.telTime.loading = false;
                            });
                    } else {
                        this.$message.error(errorMessage);
                    }
                });
            },
            stopTelTime() {
                clearInterval(this.timerObj.telTime.obj);
                this.timerObj.telTime.num = 0;
            },

            submitMobile() {
                this.$refs["mobileBox"].validate((valid) => {
                    if (valid) {
                        const params1 = {
                            ...this.mobileBox,
                            bindType: 0,
                        };

                        bindAccountApi(params1).then((res) => {
                            if (res.code == 200) {
                                this.getAccount();
                                this.mobilelVisible = false;
                            }
                        });
                    } else {
                        // console.log("error submit!!");
                        return false;
                    }
                });
            },
            submitIdentity() {
                this.$refs["identityBox"].validate((valid) => {
                    if (valid) {
                        const params = {
                            ...this.identityBox,
                        };

                        identityApi(params).then((res) => {
                            if (res.code == 200) {
                                this.identityVisible = false;
                                this.getAccount();
                            }
                        });
                    } else {
                        // console.log("error submit!!");
                        return false;
                    }
                });
            },

            goResource() {
                this.$router.push('/user/resource');
            },

            pageChange(pageIndex) {
                this.pageObj = Object.assign({}, this.pageObj, {
                    pageIndex
                });

                this.getList();
            },

            getList() {
                const {
                    pageIndex,
                    pageSize
                } = this.pageObj;

                const params = {
                    'pointsType': this.tabsValue,
                    pageSize,
                    pageNum: pageIndex,
                };

                this.tableLoading = true;

                pointsListApi(params).then((response) => {
                    const {
                        code,
                        data
                    } = response;
                    if (code === 200) {
                        const {
                            points = 0, pointsRecordList: {
                                list = [],
                                total = 0,
                                pageNum = 1
                            } = {}
                        } = data;
                        this.pageObj = Object.assign({}, this.pageObj, {
                            total,
                            pageIndex: pageNum
                        })
                        this.totalPoints = points;
                        this.tableList = list;
                        console.log(
                            this.tableList
                        );
                    }

                    this.tableLoading = false;
                });
            },

            // tab点击事件
            tabClick(tab) {
                if (tab.name != 3) {
                    this.tabsValue = tab.name;
                    this.pageChange(1);
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .integral-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        margin-bottom: 20px;
        height: 80px;
        .points{
            padding-top: 0.625rem;
            padding-left: 10px;
            box-sizing: border-box;
            padding-right: 0.625rem;
            height: 40px;
            border-radius: 5px;
            background-color: #1c6f6e ;
            color:#fff ;
            font-weight: 500;
            img{
              width: 20px;
              vertical-align: middle;
            }
        }
        .searchPointImg{
            vertical-align: top;
        }
        .searchPointTxt{
           overflow: hidden;
        }
    }

    .page-box {
        padding: 30px 0;
        text-align: center;
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1c6f6e;
        color: #FFF !important;
    }
    /deep/.el-pager li:hover {
        color: #1c6f6e !important;
    }
    /deep/.el-tabs__item.is-active{
        color: #1c6f6e;
        font-size: 14px;
    }

    /deep/.el-tabs__item:hover{
        color: #1c6f6e;
    }

    .BuyPointsMsg{
        font-size: 16px;
        line-height: 22px;
        text-align: center;
    }
</style>
